/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCursorText = createReactComponent("outline", "cursor-text", "IconCursorText", [["path", { "d": "M10 12h4", "key": "svg-0" }], ["path", { "d": "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3", "key": "svg-1" }], ["path", { "d": "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3", "key": "svg-2" }]]);

export { IconCursorText as default };
//# sourceMappingURL=IconCursorText.mjs.map
